// import React, {useState, useEffect, useRef} from 'react'
// import './history.css';
// import history from '../images/history.png'
// import ViewPort from './ViewPort';
// import { useAuth, useInvoice } from '../AuthContext';
// import Popup from 'reactjs-popup';
// import { FaTimes, FaFilePdf, FaPrint } from 'react-icons/fa';

// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';

// function History() {

//     const {user} = useAuth();
//     const {setInvoiceNumber} = useInvoice();
//     const [invoices, setInvoices] = useState([]);
//     const [searchTerm, setSearchTerm] = useState('');
//     const [sortOrder, setSortOrder] = useState('asc');

//     const [selectedInvoiceNumber, setSelectedInvoiceNumber] = useState(null);

//     const invoiceRef = useRef();

//     useEffect(() => {

//         if (!user || !user.companyID){
//             console.log('User or companyID not available', user);
//             return;
//         }
//         const fetchInvoices = async () => {

//             try {
//                 const response = await fetch(`https://invoice.dockyardsoftware.com/api/Invoice/Company/${user.companyID}`);
//                 if (!response.ok) {
//                     throw new Error('Failed to fetch invoices');
//                 }
//                 const data = await response.json();
//                 if (data && Array.isArray(data.$values)) {
//                     setInvoices(data.$values);
//                 } else {
//                     console.error('Fetched data is not an array', data);
//                 }
//             } catch (error) {
//                 console.error(error.message);
//             }
//         };

//         fetchInvoices();
//     }, [user]);

//     const handleSort = (field) => {
//         const sortedInvoices = [...invoices].sort((a, b) => {
//             if (sortOrder === 'asc') {
//                 return a[field] > b[field] ? 1 : -1;
//             } else {
//                 return a[field] < b[field] ? 1 : -1;
//             }
//         });
//         setInvoices(sortedInvoices);
//         setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
//     };

//     const handleRowClick = (invoiceNumber) => {

//         setInvoiceNumber(invoiceNumber);
//         setSelectedInvoiceNumber(invoiceNumber);

//     };

//     const handlePDFDownload = () => {
//         const input = invoiceRef.current;
//         if (input) {
//             html2canvas(input, {
//                 scrollX: 0,
//                 scrollY: 0,
//                 useCORS: true,
//                 scale: 1
//             }).then(canvas => {
//                 const imgData = canvas.toDataURL('image/png');

//                 const canvasWidth = canvas.width;
//                 const canvasHeight = canvas.height;

//                 const dpi = window.devicePixelRatio * 96;
//                 const widthInMM = canvasWidth * 25.4 / dpi;
//                 const heightInMM = canvasHeight * 25.4 / dpi;

//                 const pdf = new jsPDF({
//                     orientation: 'p',
//                     unit: 'mm',
//                     format: [widthInMM, heightInMM]
//                 });

//                 pdf.addImage(imgData, 'PNG', 0, 0, widthInMM, heightInMM);
//                 pdf.save(`invoice_${selectedInvoiceNumber}.pdf`);
//             }).catch(err => {
//                 console.error('Error capturing the invoice:', err);
//             });
//         } else {
//             console.error('Invoice component not found');
//         }
//     };

//     const formatDate = (isoString) => {
//         const date = new Date(isoString);
//         const year = date.getFullYear();
//         const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
//         const day = String(date.getDate()).padStart(2, '0');
//         return `${year}-${month}-${day}`;
//       };

//       const filteredInvoices = Array.isArray(invoices) ? invoices.filter(invoice =>
//         invoice?.clientName?.toLowerCase()?.includes(searchTerm.toLowerCase())
//     ) : [];

//     if (!user || !user.companyID) {
//         return <div>Loading...</div>;
//     }

//   return (
//     <div className="history-container">
//         <div className="history-header">
//                 <div className='history-icon-container'>
//                     <img src={history} alt="History Icon" className="history-icon"/>
//                 </div>
//                 <div className="history-controls">
//                     <input
//                         type="text"
//                         placeholder="Search..."
//                         value = {searchTerm}
//                         onChange={(e) => setSearchTerm(e.target.value)}
//                         className="history-search"

//                     />
//                     <button onClick={() => handleSort('date')} className="history-sort">
//                         Sort by Date
//                     </button>
//                 </div>
//             </div>
//             <div className="history-table">
//                 <div className="history-table-header">
//                     <div>Invoice Number</div>
//                     <div>Client Name</div>
//                     <div>Date</div>
//                     <div>Total</div>
//                 </div>
//                 {filteredInvoices.map(invoice => (
//                     <div key={invoice.invoiceNumber} className="history-table-row" onClick={() => handleRowClick(invoice.invoiceNumber)}>
//                         <div>{invoice.invoiceNumber}</div>
//                         <div>{invoice.clientName}</div>
//                         <div>{formatDate(invoice.date)}</div>
//                         <div className='amount-row'>Rs. {invoice.total.toFixed(2)}</div>
//                     </div>
//                 ))}
//             </div>
//             {/* {showViewPort && <ViewPort />} */}
//             <Popup open={selectedInvoiceNumber !== null} closeOnDocumentClick onClose={() => setSelectedInvoiceNumber(null)}>
//                 <div className='modal'>
//                     <button className="close" onClick={() => setSelectedInvoiceNumber(null)}><FaTimes /></button>
//                     <div ref={invoiceRef}>
//                         <ViewPort />
//                     </div>
//                     <div className="modal-actions">
//                     <button className="action-button" onClick={handlePDFDownload}><FaFilePdf /> Get PDF</button>
//                         <button className="action-button"><FaPrint /> Print</button>
//                     </div>
//                 </div>
//             </Popup>
//     </div>
//   )
// }

// export default History;

import React, { useState, useEffect, useRef } from "react";
import "./history.css";
import "./modal.css";
import history from "../images/history.png";
import ViewPort from "./ViewPort";
import { useAuth, useInvoice } from "../AuthContext";
import { useNavigate } from "react-router-dom";
import Popup from "reactjs-popup";
import { FaTimes } from "react-icons/fa";
import axios from "axios";
import formbg from "../images/Formbg.png";

function History() {
  const { user } = useAuth();
  const { setInvoiceNumber } = useInvoice();
  const navigate = useNavigate();
  const [invoices, setInvoices] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [selectedInvoiceNumber, setSelectedInvoiceNumber] = useState(null);
  const [selectedInvoiceData, setSelectedInvoiceData] = useState(null);
  const [loading, setLoading] = useState(false);
  const invoiceRef = useRef();

  useEffect(() => {
    if (!user || !user.companyID) {
      console.log("User or companyID not available", user);
      return;
    }

    const fetchInvoices = async () => {
      try {
        // const response = await fetch(`http://localhost:5045/api/Invoice`);
        const response = await fetch(
          `https://invoice.dockyardsoftware.com/api/Invoice`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch invoices");
        }
        const data = await response.json();

        console.log("Fetched Invoices Data:", data);

        if (data?.$values && Array.isArray(data.$values)) {
          setInvoices(data.$values);
        } else {
          console.error("Fetched data is not an array:", data);
          setInvoices([]);
        }
      } catch (error) {
        console.error("Error fetching invoices:", error.message);
      }
    };

    fetchInvoices();
  }, [user]);

  const fetchInvoiceData = async (invoiceNumber) => {
    setLoading(true);
    try {
        //  const response = await axios.get(`http://localhost:5045/api/Invoice/${invoiceNumber}`);
      const response = await axios.get(
        `https://invoice.dockyardsoftware.com/api/Invoice/${invoiceNumber}`
      );
      const invoiceData = response.data;
      console.log("Fetched Invoice Data:", invoiceData);

      const transformedData = {
        invoiceNumber: invoiceData.invoiceNumber,
        baseInvoiceNumber: invoiceData.baseInvoiceNumber,
        clientName: invoiceData.clientName,
        mobileNumber: invoiceData.mobileNumber,
        date: invoiceData.date,
        total: invoiceData.total,
        tax: invoiceData.tax,
        discount: invoiceData.discount,
        paidAmount: invoiceData.paidAmount,
        advanceAmount: invoiceData.advanceAmount,
        remainingBalance: invoiceData.remainingBalance,
        pendingStatus: invoiceData.pendingStatus,
        items: invoiceData.items?.$values || [],
      };

      setSelectedInvoiceData(transformedData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching invoice details:", error);
      setLoading(false);
    }
  };

  const handleSort = (field) => {
    const sortedInvoices = [...invoices].sort((a, b) => {
      if (!a[field] || !b[field]) return 0;
      return sortOrder === "asc"
        ? a[field] > b[field]
          ? 1
          : -1
        : a[field] < b[field]
        ? 1
        : -1;
    });
    setInvoices(sortedInvoices);
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  const handleRowClick = (invoiceNumber) => {
    console.log("Selected Invoice:", invoiceNumber);
    setInvoiceNumber(invoiceNumber);
    setSelectedInvoiceNumber(invoiceNumber);
    fetchInvoiceData(invoiceNumber);
  };

  const handlePrint = () => {
    if (!selectedInvoiceData || !selectedInvoiceData.invoiceNumber) {
      alert("Invoice data not loaded yet. Please try again.");
      return;
    }

    navigate(`/viewPort/${selectedInvoiceData.invoiceNumber}`, {
      state: { invoiceData: selectedInvoiceData },
    });
  };

  const formatDate = (isoString) => {
    if (!isoString) return "N/A";
    const date = new Date(isoString);
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      "0"
    )}-${String(date.getDate()).padStart(2, "0")}`;
  };

  // const filteredInvoices = invoices.filter(invoice =>
  //     invoice?.client?.clientName?.toLowerCase()?.includes(searchTerm.toLowerCase())
  // );

  //Search by client name and invocie also
  const filteredInvoices = invoices.filter(
    (invoice) =>
      invoice?.client?.clientName
        ?.toLowerCase()
        ?.includes(searchTerm.toLowerCase()) ||
      invoice?.invoiceNumber
        ?.toString()
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
  );

  if (!user || !user.companyID) {
    return <div>Loading...</div>;
  }

  return (
    <div className="history-container">
      <div className="history-header">
        <div className="history-icon-container">
          <img src={history} alt="History Icon" className="history-icon" />
        </div>
        <div className="history-controls">
          <input
            type="text"
            placeholder="Search by Client or Invoice Number..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="history-search"
          />
          <button onClick={() => handleSort("date")} className="history-sort">
            Sort by Date
          </button>
        </div>
      </div>

      {/* <div className="history-table">
                <div className="history-table-header">
                    <div>Invoice Number</div>
                    <div>Base Invoice Number</div>
                    <div>Client Name</div>
                    <div>Date</div>
                    <div>Total</div>
                </div>

                {filteredInvoices.length > 0 ? (
                    filteredInvoices.map((invoice, index) => (
                        <div key={index} className="history-table-row" onClick={() => handleRowClick(invoice.invoiceNumber)}>
                            <div>{invoice.invoiceNumber}</div>
                            <div>{invoice.baseInvoiceNumber}</div>
                            <div>{invoice.client?.clientName || 'N/A'}</div>
                            <div>{formatDate(invoice.date)}</div>
                            <div className='amount-row'>Rs. {invoice.total?.toFixed(2) || '0.00'}</div>
                        </div>
                    ))
                ) : (
                    <div className="no-invoices">No invoices found</div>
                )}
            </div> */}

      <div className="history-table">
        <div className="history-table-inner">
          <div className="history-table-header">
            <div>Invoice Number</div>
            <div>Base Invoice Number</div>
            <div>Client Name</div>
            <div>Date</div>
            <div>Total</div>
          </div>

          {filteredInvoices.length > 0 ? (
            filteredInvoices.map((invoice, index) => (
              <div
                key={index}
                className="history-table-row"
                onClick={() => handleRowClick(invoice.invoiceNumber)}
              >
                <div>{invoice.invoiceNumber}</div>
                <div>{invoice.baseInvoiceNumber}</div>
                <div>{invoice.client?.clientName || "N/A"}</div>
                <div>{formatDate(invoice.date)}</div>
                <div className="amount-row">
                  Rs. {invoice.total?.toFixed(2) || "0.00"}
                </div>
              </div>
            ))
          ) : (
            <div className="no-invoices">No invoices found</div>
          )}
        </div>
      </div>

      <Popup
        open={selectedInvoiceNumber !== null}
        closeOnDocumentClick
        onClose={() => {
          setSelectedInvoiceNumber(null);
          setSelectedInvoiceData(null);
        }}
        className="invoice-popup"
      >
        <div className="modal-overlay">
          <div className="modal-content">
            <button
              className="close-button"
              onClick={() => {
                setSelectedInvoiceNumber(null);
                setSelectedInvoiceData(null);
              }}
            >
              <FaTimes />
            </button>
            <div className="invoice-container" ref={invoiceRef}>
              {loading ? (
                <div className="loading-message">
                  Loading invoice details...
                </div>
              ) : selectedInvoiceData ? (
                <ViewPort
                  invoiceData={selectedInvoiceData}
                  onPrint={handlePrint}
                  invoiceRef={invoiceRef}
                />
              ) : (
                <div className="no-data-message">No invoice data available</div>
              )}
            </div>
          </div>
        </div>
      </Popup>
    </div>
  );
}

export default History;
